import React from "react";
import { Button as Btn } from "react-bootstrap";
import PropTypes from "prop-types";
import "./Button.scss";

type ButtonProps = {
  id?: string;
  variant?: "primary" | "link" | "success" | "secondary" | "danger" | "cancel" | "light" | "outline-primary" | "";
  label?: String | Object;
  size?: "sm" | "md" | "lg";
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  children?: React.ReactNode;
  disabled?: boolean;
  className?: String;
  isLoading?: boolean;
  type?: string;
  style?: React.CSSProperties;
  square?: boolean;
};

const Button: React.FC<ButtonProps> = function ({
  id,
  variant = "primary",
  label = "",
  size = "md",
  onClick,
  children,
  disabled,
  className,
  isLoading,
  type,
  style,
  square,
  ...props
}) {
  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "button-sm";
      case "md":
        return "button-md";
      case "lg":
        return "button-lg";
      default:
        return "button-md";
    }
  };

  return (
    <Btn
      id={id}
      className={`${
        square ? "" : "rounded-pill"
      } ${getSizeClass()} pt-10 pb-10 pl-11 pr-11 br-3 d-flex flex-row align-items-center justify-content-center ${className}`}
      variant={variant}
      onClick={onClick}
      {...props}
      disabled={isLoading || disabled}
      {...(type && { type })}
      style={style}
    >
      {!isLoading && (
        <>
          {children}
          {label}
        </>
      )}
      {isLoading && <div className="spinner-border spinner-border-sm" role="status" />}
    </Btn>
  );
};

export default Button;

Button.propTypes = {
  id:PropTypes.string,
  variant: PropTypes.oneOf(["primary", "link", "success", "secondary", "danger", "cancel", "light", "outline-primary", ""]),
  label: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  type: PropTypes.string,
  style: PropTypes.instanceOf(Object),
};

Button.defaultProps = {
  id:"",
  variant: "primary",
  label: "",
  size: "md",
  onClick: () => {},
  children: null,
  disabled: false,
  className: "",
  isLoading: false,
  type: "",
  style: {},
  square: false,
};
